"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var block_ui_actions_constant_1 = require("../constants/block-ui-actions.constant");
var block_ui_instance_service_1 = require("./block-ui-instance.service");
var BlockUIService = (function () {
    function BlockUIService(blockUIInstance) {
        this.blockUIInstance = blockUIInstance;
    }
    /**
    * Starts blocking for given BlockUI instance or instances
    */
    BlockUIService.prototype.start = function (target, message) {
        this.dispatch(target, block_ui_actions_constant_1.BlockUIActions.START, message);
    };
    /**
    * Stops blocking for given BlockUI instance or instances
    */
    BlockUIService.prototype.stop = function (target) {
        this.dispatch(target, block_ui_actions_constant_1.BlockUIActions.STOP);
    };
    /**
    * Unsubscribes for given BlockUI instance or instances
    */
    BlockUIService.prototype.unsubscribe = function (target) {
        this.dispatch(target, block_ui_actions_constant_1.BlockUIActions.UNSUBSCRIBE);
    };
    BlockUIService.prototype.dispatch = function (target, type, message) {
        var _this = this;
        if (target === void 0) { target = []; }
        var instances = typeof target === 'string' ? [target] : target;
        instances.forEach(function (i) { return _this.blockUIInstance.decorate(i)[type](message); });
    };
    BlockUIService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    BlockUIService.ctorParameters = function () { return [
        { type: block_ui_instance_service_1.BlockUIInstanceService, },
    ]; };
    return BlockUIService;
}());
exports.BlockUIService = BlockUIService;



//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/node_modules/ng-block-ui/dist/lib/services/block-ui.service.js
// module id = b6Rz
// module chunks = 3